var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.dynamicList),function(item,index){return _c('LayoutTitle',{key:item.groupId,attrs:{"title":item.groupName}},[_c('FormLayout',{ref:"projectForm",refInFor:true,attrs:{"readOnly":_vm.readOnly,"model":_vm.projectInfo,"list":_vm.generatePage(index)},on:{"on-change-tree":_vm.checkPerson,"on-change-all":_vm.checkMember}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }